export default __webpack_public_path__ + "static/media/household-floor-plan-2-1.8ef0a15c.png";